export const orderTypeList = [
  {
    type: 'ALL',
    text: 'ALL',
    orderStatus: [
      {
        value: 'IN_PROGRESS',
        text: 'IN PROGRESS',
        imgSrc: 'cancelled.svg',
        status: [
          'TRANSFERRED',
          'PREPARED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'PAYMENT_SUCCESS',
          'SUBMITTED',
          'PAYING_ON_CASHIER'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'NEW',
        text: 'NEW',
        imgSrc: 'cancelled.svg',
        status: ['TRANSFERRED', 'SUBMITTED', 'PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ALL',
        text: 'ALL',
        imgSrc: 'cancelled.svg',
        status: [
          'TRANSFERRED',
          'PREPARED',
          'COMPLETED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'CANCELLED',
          'PAYMENT_SUCCESS',
          'SUBMITTED',
          'INIT',
          'REFUND_SUCCESS',
          'WAITING_FOR_REFUND',
          'PAYING_ON_CASHIER'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PAYING_ON_CASHIER',
        text: 'PAYING ON CASHIER',
        imgSrc: 'cancelled.svg',
        status: ['PAYING_ON_CASHIER'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PREPARED',
        text: 'PREPARING',
        imgSrc: 'preparing.svg',
        status: ['PREPARED'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'ON_DELIVERY',
        text: 'ON DELIVERY',
        imgSrc: 'ondelivery.svg',
        status: ['ON_DELIVERY'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'READY_PICKUP',
        text: 'READY TO PICK UP',
        imgSrc: 'readtopickup.svg',
        status: ['READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PAYMENT_SUCCESS',
        text: 'PAYMENT SUCCESS',
        imgSrc: 'neworder.svg',
        status: ['PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'COMPLETED',
        text: 'COMPLETED',
        imgSrc: 'completed.svg',
        status: ['COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'CANCELLED',
        text: 'CANCELLED',
        imgSrc: 'cancelled.svg',
        status: ['CANCELLED', 'REFUND_SUCCESS', 'WAITING_FOR_REFUND'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'INIT',
        text: 'INIT',
        imgSrc: 'init.svg',
        status: ['INIT'],
        quantity: 0,
        nextStatus: 'PREPARING'
      }
    ]
  },
  {
    type: 'PPTA',
    text: 'Takeaway',
    orderStatus: [
      {
        value: 'IN_PROGRESS',
        text: 'IN PROGRESS',
        imgSrc: 'cancelled.svg',
        status: ['PAYMENT_SUCCESS', 'PREPARED', 'READY_PICKUP', 'PAYING_ON_CASHIER'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'NEW',
        text: 'NEW',
        imgSrc: 'cancelled.svg',
        status: ['PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ALL',
        text: 'ALL',
        imgSrc: 'cancelled.svg',
        status: [
          'PAYMENT_SUCCESS',
          'PREPARED',
          'READY_PICKUP',
          'COMPLETED',
          'INIT',
          'CANCELLED',
          'REFUND_SUCCESS',
          'WAITING_FOR_REFUND',
          'PAYING_ON_CASHIER'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PAYING_ON_CASHIER',
        text: 'PAYING ON CASHIER',
        imgSrc: 'cancelled.svg',
        status: ['PAYING_ON_CASHIER'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PREPARED',
        text: 'PREPARING',
        imgSrc: 'preparing.svg',
        status: ['PREPARED'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'READY_PICKUP',
        text: 'READY TO PICK UP',
        imgSrc: 'readtopickup.svg',
        status: ['READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'COMPLETED',
        text: 'COMPLETED',
        imgSrc: 'completed.svg',
        status: ['COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'INIT',
        text: 'INIT',
        imgSrc: 'init.svg',
        status: ['INIT'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'CANCELLED',
        text: 'CANCELLED',
        imgSrc: 'cancelled.svg',
        status: ['CANCELLED', 'REFUND_SUCCESS', 'WAITING_FOR_REFUND'],
        quantity: 0,
        nextStatus: 'PREPARING'
      }
    ]
  },
  {
    type: 'TOP',
    text: 'Table',
    orderStatus: [
      {
        value: 'IN_PROGRESS',
        text: 'IN PROGRESS',
        imgSrc: 'cancelled.svg',
        status: ['PREPARED', 'READY_PICKUP', 'PAYMENT_SUCCESS', 'SUBMITTED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'NEW',
        text: 'NEW',
        imgSrc: 'cancelled.svg',
        status: ['SUBMITTED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ALL',
        text: 'ALL',
        imgSrc: 'cancelled.svg',
        status: ['SUBMITTED', 'PREPARED', 'READY_PICKUP', 'COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PREPARED',
        text: 'PREPARING',
        imgSrc: 'preparing.svg',
        status: ['PREPARED'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'READY_PICKUP',
        text: 'READY TO PICK UP',
        imgSrc: 'readtopickup.svg',
        status: ['READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'COMPLETED',
        text: 'COMPLETED',
        imgSrc: 'completed.svg',
        status: ['COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      }
    ]
  },
  {
    type: 'PPDI',
    text: 'Dine In',
    orderStatus: [
      {
        value: 'IN_PROGRESS',
        text: 'IN PROGRESS',
        imgSrc: 'cancelled.svg',
        status: ['PAYMENT_SUCCESS', 'PREPARED', 'READY_PICKUP', 'PAYING_ON_CASHIER'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'NEW',
        text: 'NEW',
        imgSrc: 'cancelled.svg',
        status: ['PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ALL',
        text: 'ALL',
        imgSrc: 'cancelled.svg',
        status: [
          'PAYMENT_SUCCESS',
          'PREPARED',
          'READY_PICKUP',
          'COMPLETED',
          'CANCELLED',
          'REFUND_SUCCESS',
          'WAITING_FOR_REFUND',
          'PAYING_ON_CASHIER'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PAYING_ON_CASHIER',
        text: 'PAYING ON CASHIER',
        imgSrc: 'cancelled.svg',
        status: ['PAYING_ON_CASHIER'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PREPARED',
        text: 'PREPARING',
        imgSrc: 'preparing.svg',
        status: ['PREPARED'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'READY_PICKUP',
        text: 'READY TO PICK UP',
        imgSrc: 'readtopickup.svg',
        status: ['READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'COMPLETED',
        text: 'COMPLETED',
        imgSrc: 'completed.svg',
        status: ['COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'CANCELLED',
        text: 'CANCELLED',
        imgSrc: 'cancelled.svg',
        status: ['CANCELLED', 'REFUND_SUCCESS', 'WAITING_FOR_REFUND'],
        quantity: 0,
        nextStatus: 'PREPARING'
      }
    ]
  },
  {
    type: 'HMD',
    text: 'Delivery',
    orderStatus: [
      {
        value: 'IN_PROGRESS',
        text: 'IN PROGRESS',
        imgSrc: 'cancelled.svg',
        status: ['TRANSFERRED', 'PREPARED', 'READY_PICKUP', 'ON_DELIVERY', 'PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'NEW',
        text: 'NEW',
        imgSrc: 'cancelled.svg',
        status: ['TRANSFERRED', 'PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ALL',
        text: 'ALL',
        imgSrc: 'cancelled.svg',
        status: [
          'TRANSFERRED',
          'PREPARED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'COMPLETED',
          'PAYMENT_SUCCESS'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PREPARED',
        text: 'PREPARING',
        imgSrc: 'preparing.svg',
        status: ['PREPARED'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'READY_PICKUP',
        text: 'READY TO PICK UP',
        imgSrc: 'readtopickup.svg',
        status: ['READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ON_DELIVERY',
        text: 'ON DELIVERY',
        imgSrc: 'ondelivery.svg',
        status: ['ON_DELIVERY'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'COMPLETED',
        text: 'COMPLETED',
        imgSrc: 'completed.svg',
        status: ['COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      }
    ]
  },
  {
    type: 'OTHERS',
    text: 'Others',
    orderStatus: [
      {
        value: 'IN_PROGRESS',
        text: 'IN PROGRESS',
        imgSrc: 'cancelled.svg',
        status: ['PAYMENT_SUCCESS', 'PREPARED', 'READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'NEW',
        text: 'NEW',
        imgSrc: 'cancelled.svg',
        status: ['PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ALL',
        text: 'ALL',
        imgSrc: 'cancelled.svg',
        status: [
          'PAYMENT_SUCCESS',
          'PREPARED',
          'READY_PICKUP',
          'COMPLETED',
          'CANCELLED',
          'REFUND_SUCCESS',
          'WAITING_FOR_REFUND'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PREPARED',
        text: 'PREPARING',
        imgSrc: 'preparing.svg',
        status: ['PREPARED'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'READY_PICKUP',
        text: 'READY TO PICK UP',
        imgSrc: 'readtopickup.svg',
        status: ['READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'COMPLETED',
        text: 'COMPLETED',
        imgSrc: 'completed.svg',
        status: ['COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'CANCELLED',
        text: 'CANCELLED',
        imgSrc: 'cancelled.svg',
        status: ['CANCELLED', 'REFUND_SUCCESS', 'WAITING_FOR_REFUND'],
        quantity: 0,
        nextStatus: 'PREPARING'
      }
    ]
  },
  {
    type: 'ROOM',
    text: 'Room Service',
    orderStatus: [
      {
        value: 'IN_PROGRESS',
        text: 'IN PROGRESS',
        imgSrc: 'cancelled.svg',
        status: [
          'SUBMITTED',
          'TRANSFERRED',
          'PREPARED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'PAYMENT_SUCCESS'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'NEW',
        text: 'NEW',
        imgSrc: 'cancelled.svg',
        status: ['SUBMITTED', 'TRANSFERRED', 'PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ALL',
        text: 'ALL',
        imgSrc: 'cancelled.svg',
        status: [
          'SUBMITTED',
          'TRANSFERRED',
          'PREPARED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'COMPLETED',
          'PAYMENT_SUCCESS'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PREPARED',
        text: 'PREPARING',
        imgSrc: 'preparing.svg',
        status: ['PREPARED'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'READY_PICKUP',
        text: 'READY TO PICK UP',
        imgSrc: 'readtopickup.svg',
        status: ['READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ON_DELIVERY',
        text: 'ON DELIVERY',
        imgSrc: 'ondelivery.svg',
        status: ['ON_DELIVERY'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'COMPLETED',
        text: 'COMPLETED',
        imgSrc: 'completed.svg',
        status: ['COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      }
    ]
  }
];
export const orderTypeListRoom = [
  {
    type: 'ALL',
    text: 'ALL',
    orderStatus: [
      {
        value: 'IN_PROGRESS',
        text: 'IN PROGRESS',
        imgSrc: 'cancelled.svg',
        status: [
          'TRANSFERRED',
          'PREPARED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'PAYMENT_SUCCESS'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'NEW',
        text: 'NEW',
        imgSrc: 'cancelled.svg',
        status: ['TRANSFERRED', 'PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ALL',
        text: 'ALL',
        imgSrc: 'cancelled.svg',
        status: [
          'TRANSFERRED',
          'PREPARED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'COMPLETED',
          'PAYMENT_SUCCESS'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PREPARED',
        text: 'PREPARING',
        imgSrc: 'preparing.svg',
        status: ['PREPARED'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'READY_PICKUP',
        text: 'READY TO PICK UP',
        imgSrc: 'readtopickup.svg',
        status: ['READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ON_DELIVERY',
        text: 'ON DELIVERY',
        imgSrc: 'ondelivery.svg',
        status: ['ON_DELIVERY'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'COMPLETED',
        text: 'COMPLETED',
        imgSrc: 'completed.svg',
        status: ['COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      }
    ]
  },
  {
    type: 'ROOM',
    text: 'Room Service',
    orderStatus: [
      {
        value: 'IN_PROGRESS',
        text: 'IN PROGRESS',
        imgSrc: 'cancelled.svg',
        status: [
          'TRANSFERRED',
          'PREPARED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'PAYMENT_SUCCESS'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'NEW',
        text: 'NEW',
        imgSrc: 'cancelled.svg',
        status: ['TRANSFERRED', 'PAYMENT_SUCCESS'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ALL',
        text: 'ALL',
        imgSrc: 'cancelled.svg',
        status: [
          'TRANSFERRED',
          'PREPARED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'COMPLETED',
          'PAYMENT_SUCCESS'
        ],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'PREPARED',
        text: 'PREPARING',
        imgSrc: 'preparing.svg',
        status: ['PREPARED'],
        quantity: 0,
        nextStatus: 'READY_PICKUP'
      },
      {
        value: 'READY_PICKUP',
        text: 'READY TO PICK UP',
        imgSrc: 'readtopickup.svg',
        status: ['READY_PICKUP'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'ON_DELIVERY',
        text: 'ON DELIVERY',
        imgSrc: 'ondelivery.svg',
        status: ['ON_DELIVERY'],
        quantity: 0,
        nextStatus: 'PREPARING'
      },
      {
        value: 'COMPLETED',
        text: 'COMPLETED',
        imgSrc: 'completed.svg',
        status: ['COMPLETED'],
        quantity: 0,
        nextStatus: 'PREPARING'
      }
    ]
  }
];

// mobile side order status
export const mobileOrderItemStatus = {
  TRANSFERRED: {
    processing: false,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: true,
    roomService: true,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    value: 'TRANSFERRED',
    text: 'NEW',
    buttonValue: 'NEW',
    nextStatusButton: {
      text: 'PREPARING',
      value: 'PREPARED',
      variant: 'buttonStyle-new_order'
    },
    textStyle: 'order-new_order',
    imgSrc: 'neworder.png',
    flowPosition: 1,
    quantity: 0
  },
  PAYING_ON_CASHIER: {
    processing: false,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: true,
    roomService: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    value: 'PAYING_ON_CASHIER',
    text: 'PAYING ON CASHIER',
    buttonValue: 'PAYING ON CASHIER',
    nextStatusButton: {
      text: 'PAID',
      value: 'PAYMENT_SUCCESS',
      statusText: 'PAYMENT SUCCESS',
      confirmTitle: 'Have you receive cash from user?',
      variant: 'buttonStyle-completed'
    },
    textStyle: 'order-new_order',
    imgSrc: 'neworder.png',
    flowPosition: 1,
    quantity: 0
  },
  PAYMENT_SUCCESS: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: true,
    allorder: false,
    value: 'PAYMENT_SUCCESS',
    buttonValue: 'PAYMENT SUCCESS',
    text: 'NEW',
    nextStatusButton: {
      text: 'PREPARING',
      value: 'PREPARED',
      variant: 'buttonStyle-new_order'
    },
    textStyle: 'order-new_order',
    imgSrc: 'neworder.png',
    flowPosition: 2,
    quantity: 0
  },
  SUBMITTED: {
    processing: false,
    deliveryProcessing: false,
    roomService: false,
    takeAway: false,
    tableOrder: true,
    dineIn: false,
    buttonShow: true,
    allorder: false,
    value: 'SUBMITTED',
    text: 'NEW',
    nextStatusButton: {
      text: 'PREPARING',
      value: 'PREPARED',
      variant: 'buttonStyle-new_order'
    },
    buttonValue: 'SUBMITTED',
    textStyle: 'order-submitted',
    imgSrc: 'submitted.svg',
    flowPosition: 3,
    quantity: 0
  },
  ALL: {
    processing: false,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: true,
    roomService: true,
    takeAway: true,
    tableOrder: true,
    dineIn: true,
    value: 'ALL',
    text: 'ALL',
    buttonValue: 'ALL',
    nextStatusButton: {
      text: 'PREPARING',
      value: 'PREPARED',
      variant: 'buttonStyle-new_order'
    },
    textStyle: 'order-new_order',
    imgSrc: 'neworder.png',
    flowPosition: 1,
    quantity: 1
  },
  PREPARED: {
    processing: false,
    deliveryProcessing: true,
    roomService: true,
    takeAway: true,
    tableOrder: true,
    dineIn: true,
    buttonShow: true,
    allorder: true,
    value: 'PREPARED',
    text: 'PREPARING',
    buttonValue: 'PREPARED',
    nextStatusButton: {
      text: 'READY TO PICK UP',
      value: 'READY_PICKUP',
      variant: 'buttonStyle-readypickup'
    },
    textStyle: 'order-accepted',
    imgSrc: 'preparing.svg',
    flowPosition: 4,
    quantity: 0
  },
  READY_PICKUP: {
    processing: false,
    deliveryProcessing: true,
    roomService: true,
    takeAway: true,
    tableOrder: true,
    dineIn: true,
    buttonShow: true,
    allorder: true,
    value: 'READY_PICKUP',
    text: 'READY TO PICK UP',
    buttonValue: 'READY',
    nextStatusButton: {
      text: 'ON DELIVERY',
      value: 'ON_DELIVERY',
      variant: 'buttonStyle-on_delivery'
    },
    textStyle: 'order-readypickup',
    imgSrc: 'readtopickup.svg',
    flowPosition: 5,
    quantity: 0
  },
  ON_DELIVERY: {
    processing: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    deliveryProcessing: true,
    roomService: true,
    buttonShow: true,
    allorder: true,
    value: 'ON_DELIVERY',
    text: 'ON DELIVERY',
    nextStatusButton: {
      text: 'COMPLETED',
      value: 'COMPLETED',
      variant: 'buttonStyle-delivered'
    },
    buttonValue: 'ONDELIVERY',
    textStyle: 'order-ondelivery',
    imgSrc: 'ondelivery.svg',
    flowPosition: 6,
    quantity: 0
  },
  COMPLETED: {
    processing: false,
    takeAway: true,
    tableOrder: true,
    dineIn: true,
    deliveryProcessing: true,
    roomService: true,
    buttonShow: true,
    voidButton: true,
    hideNextStatusButton: true,
    allorder: true,
    value: 'COMPLETED',
    text: 'COMPLETED',
    nextStatusButton: [],
    buttonValue: 'COMPLETED',
    textStyle: 'order-completed',
    buttonStyle: 'buttonStyle-delivered',
    imgSrc: 'completed.svg',
    flowPosition: 7,
    quantity: 0
  },
  CANCELLED: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: false,
    allorder: true,
    value: 'CANCELLED',
    text: 'CANCELLED',
    nextStatusButton: [],
    buttonValue: 'CANCELLED',
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'cancelled.svg',
    flowPosition: 8,
    quantity: 0
  },
  WAITING_FOR_REFUND: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    deliveryProcessing: false,
    buttonShow: false,
    allorder: true,
    value: 'CANCELLED',
    text: 'CANCELLED, WAITING FOR REFUND',
    nextStatusButton: [],
    buttonValue: 'CANCELLED',
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'cancelled.svg',
    flowPosition: 8,
    quantity: 0
  },
  REFUND_SUCCESS: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    deliveryProcessing: false,
    buttonShow: false,
    allorder: true,
    value: 'CANCELLED',
    text: 'CANCELLED, REFUND SUCCESS',
    nextStatusButton: [],
    buttonValue: 'CANCELLED',
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'cancelled.svg',
    flowPosition: 8,
    quantity: 0
  },
  INIT: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: false,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: false,
    allorder: true,
    value: 'INIT',
    text: 'INT',
    nextStatusButton: [],
    textStyle: 'order-init',
    buttonValue: 'INT',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'init.svg',
    flowPosition: 9,
    quantity: 0
  },
  'In Progress': {
    processing: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: false,
    allorder: false,
    value: 'In Progress',
    text: 'In Progress',
    nextStatusButton: [],
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'cancelled.svg',
    flowPosition: 10,
    quantity: 0
  }
};
// desktop side order status
export const desktopOrderItemStatus = {
  TRANSFERRED: {
    processing: false,
    tableOrder: false,
    takeAway: false,
    dineIn: false,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: true,
    roomService: true,
    value: 'TRANSFERRED',
    text: 'NEW ORDER',
    leftButton: 'REJECT',
    textStyle: 'order-new_order',
    buttonStyle: 'buttonStyle-new_order',
    imgSrc: 'neworder.png',
    variantStyle: 'outline-warning',
    flowPosition: 1,
    quantity: 0
  },
  PAYING_ON_CASHIER: {
    processing: false,
    tableOrder: false,
    takeAway: true,
    dineIn: true,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: true,
    roomService: false,
    value: 'PAYING_ON_CASHIER',
    text: 'PAYING ON CASHIER',
    leftButton: 'REJECT',
    nextStatus: 'PAID',
    textStyle: 'order-new_order',
    buttonStyle: 'buttonStyle-new_order',
    imgSrc: 'neworder.png',
    variantStyle: 'outline-warning',
    flowPosition: 1,
    quantity: 0
  },
  PRED: {
    processing: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: false,
    allorder: false,
    value: 'PREPARED',
    text: 'PREPARING',
    leftButton: 'REJECT',
    textStyle: 'order-accepted',
    buttonStyle: 'buttonStyle-new_order',
    imgSrc: 'preparing.svg',
    flowPosition: 2,
    quantity: 0
  },
  PAYMENT_SUCCESS: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: true,
    allorder: false,
    leftButton: 'REJECT',
    value: 'PAYMENT_SUCCESS',
    text: 'NEW ORDER',
    textStyle: 'order-new_order',
    buttonStyle: 'buttonStyle-submitted',
    imgSrc: 'neworder.png',
    flowPosition: 3,
    quantity: 0
  },
  PAID: {
    processing: false,
    tableOrder: false,
    takeAway: true,
    dineIn: true,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: true,
    roomService: false,
    value: 'PAYMENT_SUCCESS',
    text: 'PAID',
    leftButton: 'REJECT',
    textStyle: 'order-completed',
    buttonStyle: 'buttonStyle-completed',
    statusText: 'PAYMENT SUCCESS',
    confirmTitle: 'Have you receive cash from user?',
    imgSrc: 'neworder.png',
    variantStyle: 'outline-warning',
    flowPosition: 3,
    quantity: 0
  },
  PRE: {
    processing: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: false,
    allorder: false,
    value: 'PREPARED',
    text: 'PREPARING',
    leftButton: 'REJECT',
    textStyle: 'order-accepted',
    buttonStyle: 'buttonStyle-new_order',
    imgSrc: 'preparing.svg',
    flowPosition: 4,
    quantity: 0
  },
  SUBMITTED: {
    processing: false,
    deliveryProcessing: false,
    roomService: false,
    takeAway: false,
    tableOrder: true,
    dineIn: false,
    buttonShow: true,
    allorder: false,
    value: 'SUBMITTED',
    text: 'NEW ORDER',
    leftButton: 'REJECT',
    buttonValue: 'SUBMITTED',
    textStyle: 'order-submitted',
    buttonStyle: 'buttonStyle-submitted',
    imgSrc: 'submitted.svg',
    flowPosition: 5,
    quantity: 0
  },
  ALL: {
    processing: false,
    tableOrder: true,
    takeAway: true,
    dineIn: true,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: true,
    roomService: true,
    value: 'ALL',
    text: 'ALL',
    leftButton: 'REJECT',
    textStyle: 'order-new_order',
    buttonStyle: 'buttonStyle-new_order',
    imgSrc: 'neworder.png',
    variantStyle: 'outline-warning',
    flowPosition: 1,
    quantity: 0
  },
  PREDCOPY: {
    processing: false,
    deliveryProcessing: false,
    roomService: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    buttonShow: false,
    allorder: false,
    value: 'PREPARED',
    text: 'PREPARING',
    buttonValue: 'CONFIRM',
    leftButton: 'REJECT',
    textStyle: 'order-accepted',
    buttonStyle: 'buttonStyle-new_order',
    imgSrc: 'preparing.svg',
    flowPosition: 6,
    quantity: 0
  },
  PAYED: {
    processing: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: true,
    allorder: false,
    value: 'COMPLETED',
    buttonValue: 'PAYED',
    text: 'PAYED',
    leftButton: 'REJECT',
    textStyle: 'order-accepted',
    buttonStyle: 'buttonStyle-payed',
    imgSrc: 'accepted.svg',
    flowPosition: 7,
    quantity: 0
  },
  PREPARED: {
    processing: false,
    takeAway: true,
    tableOrder: true,
    dineIn: true,
    deliveryProcessing: true,
    roomService: true,
    buttonShow: true,
    allorder: false,
    value: 'PREPARED',
    text: 'PREPARING',
    leftButton: 'CANCEL',
    textStyle: 'order-accepted',
    buttonStyle: 'buttonStyle-new_order',
    imgSrc: 'preparing.svg',
    flowPosition: 8,
    quantity: 0
  },
  READY_PICKUP: {
    processing: false,
    takeAway: true,
    tableOrder: true,
    dineIn: true,
    deliveryProcessing: true,
    roomService: true,
    buttonShow: true,
    allorder: false,
    value: 'READY_PICKUP',
    text: 'READY TO PICK UP',
    leftButton: 'CANCEL',
    textStyle: 'order-readypickup',
    buttonStyle: 'buttonStyle-readypickup',
    imgSrc: 'readtopickup.svg',
    variantStyle: 'outline-success',
    flowPosition: 9,
    quantity: 0
  },
  ON_DELIVERY: {
    processing: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    deliveryProcessing: true,
    roomService: true,
    buttonShow: true,
    allorder: false,
    value: 'ON_DELIVERY',
    text: 'ON DELIVERY',
    leftButton: 'CANCEL',
    textStyle: 'order-ondelivery',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'ondelivery.svg',
    flowPosition: 10,
    quantity: 0
  },
  COMPLETED: {
    processing: false,
    takeAway: true,
    tableOrder: true,
    dineIn: true,
    deliveryProcessing: true,
    roomService: true,
    buttonShow: true,
    allorder: true,
    value: 'COMPLETED',
    text: 'COMPLETED',
    leftButton: 'CANCEL',
    nextStatus: 'VOID',
    textStyle: 'order-completed',
    buttonStyle: 'buttonStyle-delivered',
    imgSrc: 'completed.svg',
    flowPosition: 11,
    quantity: 0
  },
  INIT: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: false,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: false,
    allorder: true,
    value: 'INIT',
    text: 'INT',
    textStyle: 'order-init',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'init.svg',
    flowPosition: 12,
    quantity: 0
  },
  CANCELLED: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: false,
    allorder: true,
    value: 'CANCELLED ',
    text: 'CANCELLED',
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'cancelled.svg',
    flowPosition: 13,
    quantity: 0
  },
  VOID: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: true,
    voidButton: true,
    hideNextStatusButton: true,
    allorder: true,
    value: 'CANCELLED ',
    text: 'CANCELLED',
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'cancelled.svg',
    flowPosition: 13,
    quantity: 0
  },
  WAITING_FOR_REFUND: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    deliveryProcessing: false,
    buttonShow: false,
    allorder: true,
    value: 'CANCELLED ',
    text: 'CANCELLED, WAITING FOR REFUND',
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'cancelled.svg',
    flowPosition: 13,
    quantity: 0
  },
  REFUND_SUCCESS: {
    processing: false,
    takeAway: true,
    tableOrder: false,
    dineIn: true,
    deliveryProcessing: false,
    buttonShow: false,
    allorder: true,
    value: 'CANCELLED ',
    text: 'CANCELLED, REFUND_SUCCESS',
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'cancelled.svg',
    flowPosition: 13,
    quantity: 0
  },
  'In Progress': {
    processing: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    deliveryProcessing: false,
    roomService: false,
    buttonShow: false,
    allorder: false,
    value: 'In Progress',
    text: 'In Progress',
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-on_delivery',
    imgSrc: 'cancelled.svg',
    flowPosition: 14,
    quantity: 0
  },
};

// mobile side bill status
export const mobileBillItemStatus = {
  ALL: {
    processing: false,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: false,
    roomService: true,
    takeAway: false,
    tableOrder: true,
    dineIn: false,
    value: 'ALL',
    text: 'ALL',
    nextStatusButton: [{ text: 'PAID', value: 'PAID', variant: 'info' }],
    textStyle: 'bill-cashier-payment',
    buttonStyle: 'buttonStyle-completed',
    imgSrc: 'blueWallet.svg',
    variantStyle: 'outline-warning',
    flowPosition: 1,
    quantity: 0
  },
  'IN PROGRESS': {
    processing: false,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: false,
    roomService: true,
    takeAway: false,
    tableOrder: true,
    dineIn: false,
    value: 'IN_PROGRESS',
    text: 'IN PROGRESS',
    nextStatusButton: [{ text: 'PAID', value: 'PAID', variant: 'info' }],
    textStyle: 'bill-cashier-payment',
    buttonStyle: 'buttonStyle-completed',
    imgSrc: 'blueWallet.svg',
    variantStyle: 'outline-warning',
    flowPosition: 1,
    quantity: 0
  },
  OPEN: {
    processing: false,
    buttonShow: true,
    allorder: false,
    deliveryProcessing: false,
    roomService: true,
    takeAway: false,
    tableOrder: true,
    dineIn: false,
    value: 'OPEN',
    text: 'OPEN',
    nextStatusButton: [
      { text: 'OVERRIDE', value: 'OVERRIDE', variant: 'outline-danger' }
    ],
    textStyle: 'bill-open',
    buttonStyle: 'buttonStyle-completed',
    imgSrc: 'open.svg',
    variantStyle: 'outline-warning',
    flowPosition: 3,
    quantity: 0
  },

  'REQUESTING CASHIER PAYMENT': {
    processing: false,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: false,
    roomService: false,
    takeAway: false,
    tableOrder: true,
    dineIn: false,
    value: 'PAYING_ON_CASHIER',
    text: 'REQUESTING CASHIER PAYMENT',
    nextStatusButton: [{ text: 'PAID', value: 'PAID', variant: 'info' }],
    textStyle: 'bill-cashier-payment',
    buttonStyle: 'buttonStyle-completed',
    imgSrc: 'blueWallet.svg',
    variantStyle: 'outline-warning',
    flowPosition: 1,
    quantity: 0
  },

  'PAYING AT HOTEL': {
    processing: false,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: false,
    roomService: true,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    value: 'PAYING_AT_HOTEL',
    text: 'PAYING AT HOTEL',
    nextStatusButton: [{ text: 'PAID', value: 'PAID', variant: 'info' }],
    textStyle: 'bill-cashier-payment',
    buttonStyle: 'buttonStyle-completed',
    imgSrc: 'blueWallet.svg',
    variantStyle: 'outline-warning',
    flowPosition: 1,
    quantity: 0
  },

  PAID: {
    processing: false,
    buttonShow: true,
    allorder: true,
    deliveryProcessing: false,
    roomService: true,
    takeAway: false,
    tableOrder: true,
    dineIn: false,
    value: 'PAID',
    text: 'PAID',
    nextStatusButton: [
      { text: 'COMPLETED', value: 'COMPLETED', variant: 'info' }
    ],
    textStyle: 'bill-paid',
    buttonStyle: 'buttonStyle-completed',
    imgSrc: 'neworder.svg',
    variantStyle: 'outline-warning',
    flowPosition: 2,
    quantity: 0
  },

  COMPLETED: {
    processing: false,
    buttonShow: false,
    allorder: true,
    deliveryProcessing: false,
    roomService: true,
    takeAway: false,
    tableOrder: true,
    dineIn: false,
    value: 'COMPLETED',
    text: 'COMPLETED',
    nextStatusButton: [],
    textStyle: 'buttonStyle-completed',
    buttonStyle: 'buttonStyle-completed',
    imgSrc: 'billCompleted.svg',
    variantStyle: 'outline-warning',
    flowPosition: 4,
    quantity: 0
  },
  CANCELLED: {
    processing: false,
    buttonShow: false,
    allorder: true,
    deliveryProcessing: false,
    roomService: true,
    takeAway: false,
    tableOrder: true,
    dineIn: false,
    value: 'CANCELLED',
    text: 'CANCELLED',
    nextStatusButton: [],
    textStyle: 'order-cancelled',
    buttonStyle: 'buttonStyle-completed',
    imgSrc: 'cancelled.svg',
    variantStyle: 'outline-warning',
    flowPosition: 5,
    quantity: 0
  },
  ISSUE: {
    processing: false,
    buttonShow: false,
    allorder: false,
    deliveryProcessing: false,
    roomService: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    value: 'ISSUE',
    text: 'ISSUE',
    nextStatusButton: [],
    textStyle: 'order-init',
    buttonStyle: 'order-init',
    imgSrc: 'init.svg',
    variantStyle: 'outline-warning',
    flowPosition: 6,
    quantity: 0
  },
  'PAYMENT FAILED': {
    processing: false,
    buttonShow: true,
    allorder: false,
    deliveryProcessing: false,
    roomService: false,
    takeAway: false,
    tableOrder: false,
    dineIn: false,
    value: 'PAYMENT FAILED',
    text: 'PAYMENT FAILED',
    nextStatusButton: [
      { text: 'OVERRIDE', value: 'OVERRIDE', variant: 'outline-danger' }
    ],
    textStyle: 'order-init',
    buttonStyle: 'order-init',
    imgSrc: 'init.svg',
    variantStyle: 'outline-warning',
    flowPosition: 7,
    quantity: 0
  }
};
